import React from "react";
import { useNavigate } from "react-router-dom";
import useIdentityVerification from "../../../hooks/useIdentityVerification";
import useUserStore from "../../../store/userStore";
import { useLanguage } from "../../../hooks/useLanguage";

function JoinVerification() {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const { updateJoinVerificationInfo } = useUserStore();

    // 개인 회원가입 인증
    const { handleIdentity: handlePersonalIdentity } = useIdentityVerification({
        context: 'join',
        memberKind: 'personal'
    });

    // 사업자 회원가입 인증
    const { handleIdentity: handleCorporateIdentity } = useIdentityVerification({
        context: 'join',
        memberKind: 'corporate'
    });

    // 로컬에서 테스트를 하기 위한 함수
    const handleTest = () => {
        updateJoinVerificationInfo({
            ci: '1',
            di: '1',
            username: '1',
            mem_phone: '1',
            gender: '0',
            birthdate: '20910910',
            memberKind: "personal"
            // memberKind: "corporate"
        });
        navigate('/joinForm');
    };

    // 개인 회원가입 버튼 클릭
    const handlePersonalJoin = () => {
        localStorage.setItem('member_kind', 'personal');
        handlePersonalIdentity();
    };

    // 기업 회원가입 버튼 클릭
    const handleCorporateJoin = () => {
        localStorage.setItem('member_kind', 'corporate');
        handleCorporateIdentity();
    };

    return (
        <div>
            <section className="auth_section">
                <div className="inner gap_32">
                    <div className="section_title">
                        <h3>{t('sign_up')}</h3>
                    </div>
                    <div className="form_wrap join_con">
                        <h6 className="sub_title">{t('phone_verification')}</h6>
                        <p className="text_center info_text">
                            {/* {t('select_member_type')}<br/> */}
                            {t('personal_income_cash_receipt')}<br/>
                            {t('personal_business_tax_invoice')}<br/>
                            {t('safe_transaction')} {t('verify_your_identity')}
                        </p>
                    </div>
                    {process.env.NODE_ENV === 'development' && (
                        <button 
                            type="button" 
                            className="default_btn black lg"
                            onClick={handleTest}
                            style={{ marginBottom: '10px' }}
                        >
                            테스트
                        </button>
                    )}
                    <div className="flex-4">
                        {/* 개인 회원가입 */}
                        <button 
                            type="button" 
                            className="default_btn white lg"
                            onClick={handlePersonalJoin}
                        >
                            {t('general_member_registration')}
                        </button>
                        {/* 사업자 회원가입 */}
                        <button 
                            type="button" 
                            className="default_btn orange lg"
                            onClick={handleCorporateJoin}
                        >
                            {t('business_registration')}
                        </button>
                    </div>
                </div>
            </section>
            
            {/* NICE 인증을 위한 숨겨진 폼 */}
            <form 
                id="niceAuthForm" 
                name="niceAuthForm" 
                action="https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb"
                method="post"
                style={{ display: 'none' }}
            >
                <input type="hidden" id="m" name="m" value="service" />
                <input type="hidden" id="token_version_id" name="token_version_id" value="" />
                <input type="hidden" id="enc_data" name="enc_data" value="" />
                <input type="hidden" id="integrity_value" name="integrity_value" value="" />
                <input type="hidden" id="receivedata" name="receivedata" value="" />
            </form>
        </div>
    );
}

export default JoinVerification;